module.exports = __webpack_public_path__ + "static/media/nortification_register_current.c86a9543.svg";